/**
 * DER CHAT-KOPF ZEIGT DIESELBE TAETIGKEIT WIE RAUM UND KARTE (Rafael, 29.09.2026 ~10:18Z:
 * „warum steht eine Bühne, die offensichtlich arbeitet, vor mir und nicht im Sitzungssaal?").
 *
 * Sie arbeitete nicht. Die Buehne stand richtig im Warteraum, gerechnet aus
 * `sitzungsTaetigkeit` (Transkript-Ende + Sperr-Register der Konten). Der Kopf des
 * Beraterchats las dagegen das Speicherregister `/api/mission/states` bzw. dessen
 * WebSocket-Ereignisse, und das kann ein Zugende verpassen: gemessen 10:28Z, 1ca00f8c
 * beendet seinen Zug um 10:27:37, das Register steht seit 10:27:47 auf `working`.
 * Zwei Wahrheiten ueber dieselbe Sitzung an einem Bildschirm.
 *
 * Deshalb wird die Messung des Guides (`GET /api/guide/sitzungen-hier/taetigkeit/:id`)
 * hier auf die Anzeigewerte des Kopfes abgebildet. `null` heisst: keine Messung (Nicht-Admin,
 * Sitzung in einem anderen Haus, Zustand unbekannt). Dann zeigt der Kopf weiter das
 * Register, denn eine andere Aussage hat dieser Rechner ueber die Sitzung nicht.
 */
export type TaetigkeitArt =
  | 'arbeitet' | 'limit' | 'wartet_auf_karte' | 'wartet_auf_antwort' | 'still' | 'tot' | 'beendet' | 'unbekannt';

export interface GemesseneTaetigkeit { art: TaetigkeitArt; wort: string; seit: string | null; quelle?: string }

export interface KopfZustand {
  attention: 'idle' | 'working' | 'needs_attention';
  reason: string | undefined;
  /** Der Satz der Messung, als Tooltip am Kopf. */
  wort: string;
}

export function kopfAusTaetigkeit(t: GemesseneTaetigkeit | null | undefined): KopfZustand | null {
  if (!t) return null;
  switch (t.art) {
    case 'arbeitet': return { attention: 'working', reason: undefined, wort: t.wort };
    case 'limit': return { attention: 'needs_attention', reason: 'rate_limit', wort: t.wort };
    case 'wartet_auf_karte':
    case 'wartet_auf_antwort':
    case 'still':
    case 'tot':
      return { attention: 'idle', reason: 'done', wort: t.wort };
    case 'beendet': return { attention: 'idle', reason: undefined, wort: t.wort };
    case 'unbekannt': return null;
  }
}
